import React from "react";

const BeforAfterWS = ({ beforService, afterService }) => {
  return (
    <div className="d-flex justify-content-between">
      <div style={{ fontSize: "12px" }}>{beforService} km</div>
      <div style={{ fontSize: "12px" }}>{afterService} km</div>
    </div>
  );
};

export default BeforAfterWS;

